import React from 'react'
import { Link } from '@noissue-ui-kit/oldBranding/link'
import { Button } from '@noissue-ui-kit/button'

export function SummaryStickyFooter({
  leftLink,
  taxTag,
  price,
  salePrice,
  variantOptions,
  callToActionButton,
}: {
  price: string
  salePrice?: string
  taxTag?: string
  leftLink?: { text: string; onClick: () => void }
  variantOptions?: { key: string; value: string; supportText?: string }[]
  callToActionButton: {
    text: string
    onClick: () => void
    disabled?: boolean
    loading: boolean
  }
}) {
  return (
    <footer className="fixed bottom-0 left-0 w-full border-2 bg-core-white border-black-20 z-1 font-mori">
      <div className="flex items-center justify-between max-w-screen-xl px-4 m-auto md:px-16">
        {leftLink && (
          <Link
            onClick={leftLink.onClick}
            size={'m'}
            iconName="HiArrowLeft"
            iconSide="left"
            className="hidden p-4 sm:block"
          >
            {leftLink.text}
          </Link>
        )}
        <div className="sm:ml-auto mr-7 sm:mr-12">
          <div className="flex items-center uppercase">
            <div
              className="text-2xl font-bold md:text-4xl text-acai"
              aria-label="Product price"
            >
              {salePrice || price}
            </div>
            {taxTag && (
              <div className="ml-2 text-xl font-bold text-acai">{taxTag}</div>
            )}
          </div>

          {variantOptions?.map((variantOption) => (
            <div
              className="flex items-center justify-between"
              key={variantOption.key}
            >
              <div className="mr-6 text-xl font-bold text-boulder">
                {variantOption.key}
              </div>
              <div className="mr-3 text-xl text-boulder">
                {variantOption.value}
              </div>
              <div className="text-lg font-semibold text-acai">
                {variantOption.supportText}
              </div>
            </div>
          ))}
        </div>
        {callToActionButton && (
          <Button
            size={'m'}
            corners={'rounded'}
            className="my-6"
            disabled={callToActionButton?.disabled || false}
            onClick={callToActionButton.onClick}
            ariaLabel={'Add To Cart'}
            loading={callToActionButton?.loading}
          >
            {callToActionButton.text}
          </Button>
        )}
      </div>
    </footer>
  )
}
